import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "_mt-3 _flex _gap-1"
}
const _hoisted_2 = { class: "_pa-3" }
const _hoisted_3 = { class: "_tc--gray" }
const _hoisted_4 = {
  key: 2,
  class: "_ba-1 _rounded--input _bc--input _pa-2 _tac",
  "data-qa": "mini-wizard-item:Empty"
}
const _hoisted_5 = {
  key: 0,
  class: "_flexwrap _jc-sb _ai-c",
  "data-qa": "mini-wizard:YourPledge"
}
const _hoisted_6 = {
  class: "_flexwrap _jc-sb _ai-c",
  "data-qa": "mini-wizard:YourPledge"
}
const _hoisted_7 = {
  key: 0,
  class: "gfu-project-mini-wizard__caption _flex-basis-100",
  "data-qa": "mini-wizard-item-warning:Tax"
}
const _hoisted_8 = {
  key: 4,
  class: "_tac"
}
const _hoisted_9 = {
  key: 5,
  class: "_tac"
}
const _hoisted_10 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_mini_wizard_sticky_gift_cards = _resolveComponent("mini-wizard-sticky-gift-cards")
  const _component_mini_wizard_sticky_backer = _resolveComponent("mini-wizard-sticky-backer")
  const _component_mini_wizard_sticky_amount = _resolveComponent("mini-wizard-sticky-amount")
  const _component_base_button = _resolveComponent("base-button")
  const _component_mini_wizard_sticky_collapsible = _resolveComponent("mini-wizard-sticky-collapsible")
  const _component_mini_wizard_sticky_header = _resolveComponent("mini-wizard-sticky-header")
  const _component_mini_wizard_sticky_reward = _resolveComponent("mini-wizard-sticky-reward")
  const _component_divider_labeled = _resolveComponent("divider-labeled")
  const _component_mini_wizard_items_content = _resolveComponent("mini-wizard-items-content")
  const _component_project_promo_item = _resolveComponent("project-promo-item")
  const _component_mini_wizard_sticky_price = _resolveComponent("mini-wizard-sticky-price")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_mini_wizard_sticky_submit = _resolveComponent("mini-wizard-sticky-submit")
  const _component_mini_wizard_sticky_footer = _resolveComponent("mini-wizard-sticky-footer")
  const _component_mini_wizard_sticky = _resolveComponent("mini-wizard-sticky")

  return ($options.isMiniWizardVisible)
    ? (_openBlock(), _createBlock(_component_mini_wizard_sticky, {
        key: 0,
        "is-processing": _ctx.isProcessing,
        "data-qa": "project-mini-wizard"
      }, _createSlots({
        header: _withCtx(() => [
          (_ctx.isPledgePlaced)
            ? (_openBlock(), _createBlock(_component_mini_wizard_sticky_header, {
                key: 0,
                variant: _ctx.isEditingPledge ? 'primary': 'default',
                "has-logo": _ctx.isUnmodifiedPledge,
                "data-qa": "mini-wizard-header"
              }, {
                default: _withCtx(() => [
                  (_ctx.isEditingPledge)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_base_heading, {
                          tag: "h3",
                          class: "gfu-heading--inverse gfu-hd--h4 _fw-b _mb-3",
                          "data-qa": "mini-wizard-header:Text"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardModifyingPledgeTitle), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_base_icon, {
                            name: "exclamation-circle",
                            class: "_mr-h"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardModifyingPledgeHint), 1 /* TEXT */)
                        ]),
                        ($options.isGiftCardHeaderVisible)
                          ? (_openBlock(), _createBlock(_component_mini_wizard_sticky_gift_cards, {
                              key: 0,
                              class: "_mt-3"
                            }))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_mini_wizard_sticky_backer),
                        _createVNode(_component_mini_wizard_sticky_amount),
                        (_ctx.canResumePayment)
                          ? (_openBlock(), _createBlock(_component_base_button, {
                              key: 0,
                              tag: "a",
                              display: "block",
                              width: "narrow",
                              theme: "transparentInverse",
                              href: _ctx.currentPledge.resumeOrderUrl,
                              class: "_mt-2",
                              "data-qa": "mini-wizard-button:ResumePayment"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardResumePaymentButton), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["href"]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.isInProcessingPaymentMode)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                              _createVNode(_component_base_icon, { name: "circle-info" }),
                              _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardProcessingPaymentInfo), 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.canEditPledge)
                          ? (_openBlock(), _createBlock(_component_base_button, {
                              key: 2,
                              type: "button",
                              display: "block",
                              width: "narrow",
                              theme: "transparentInverse",
                              disabled: _ctx.isProcessing,
                              class: "_mt-2",
                              onClick: _ctx.onEditPledge,
                              "data-qa": "mini-wizard-button:EditPledge"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardEditPledgeButton), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"]))
                          : _createCommentVNode("v-if", true),
                        ($options.isCollapsible)
                          ? (_openBlock(), _createBlock(_component_mini_wizard_sticky_collapsible, {
                              key: 3,
                              "is-collapsed": _ctx.isCollapsed,
                              onToggleCollapsed: $options.onToggleCollapsed
                            }, null, 8 /* PROPS */, ["is-collapsed", "onToggleCollapsed"]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["variant", "has-logo"]))
            : ($options.isGiftCardHeaderVisible)
              ? (_openBlock(), _createBlock(_component_mini_wizard_sticky_header, {
                  key: 1,
                  variant: "default",
                  "data-qa": "mini-wizard-header"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_mini_wizard_sticky_gift_cards)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
          ($options.isFeaturedRewardVisible)
            ? (_openBlock(), _createBlock(_component_mini_wizard_sticky_reward, { key: 2 }))
            : _createCommentVNode("v-if", true)
        ]),
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            ($options.isFeaturedRewardVisible)
              ? (_openBlock(), _createBlock(_component_divider_labeled, {
                  key: 0,
                  class: "_tc--disabled _mb-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardDividerLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (!_ctx.allItemsRemoved)
              ? (_openBlock(), _createBlock(_component_mini_wizard_items_content, {
                  key: 1,
                  "buttons-theme": $options.miniWizardItemContentButtonsTheme,
                  "addons-section": _ctx.addonsSection,
                  "can-delete-items": _ctx.canDeleteItems,
                  "delete-method": _ctx.onDeleteItem,
                  "is-unmodified-pledge": _ctx.isUnmodifiedPledge,
                  "pledge-date": _ctx.pledgeDate,
                  "rewards-section": _ctx.rewardsSection,
                  "show-addons": !_ctx.isPledgeEmpty,
                  "show-delete-button": false,
                  "show-rewards": !_ctx.allChargeableItemsRemoved,
                  "show-rewards-header": !$options.isFeaturedRewardVisible
                }, null, 8 /* PROPS */, ["buttons-theme", "addons-section", "can-delete-items", "delete-method", "is-unmodified-pledge", "pledge-date", "rewards-section", "show-addons", "show-rewards", "show-rewards-header"]))
              : _createCommentVNode("v-if", true),
            ($options.removedAllItemsLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($options.removedAllItemsLabel), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.promoItem && _ctx.isPledgeEmpty)
              ? (_openBlock(), _createBlock(_component_project_promo_item, {
                  key: 3,
                  "image-size": 36,
                  class: "gfu-1of1 gfu-bt gfu-bt--caption _mt-3",
                  "data-qa": "mini-wizard-expandable-project-promo-item"
                }))
              : _createCommentVNode("v-if", true)
          ], 512 /* NEED_PATCH */), [
            [_vShow, !$options.effectiveIsCollapsed]
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (!_ctx.isPledgeEmpty || _ctx.allItemsRemoved)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _withDirectives(_createVNode(_component_mini_wizard_sticky_footer, { class: "_flexcol _gap-2" }, {
                  default: _withCtx(() => [
                    (!_ctx.isUnmodifiedPledge)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.isEditingPledge)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_base_heading, { variant: "light" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardModifyingPledgeCostBeforeLabel), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_mini_wizard_sticky_price, {
                                  price: _ctx.pledge.parentOrder.totalValueConverted,
                                  "data-qa": "mini-wizard:OriginalPledge"
                                }, null, 8 /* PROPS */, ["price"])
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_base_heading, { variant: "light" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.yourPledgeLabel) + " ", 1 /* TEXT */),
                                _createVNode(_component_tooltip, {
                                  "icon-name": "circle-info",
                                  text: _ctx.Resources.ProjectHome.MiniWizardNoShippingTooltip
                                }, null, 8 /* PROPS */, ["text"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_mini_wizard_sticky_price, {
                              price: _ctx.pledge.totalValueConverted,
                              "data-qa": "mini-wizard:YourPledgePrice"
                            }, null, 8 /* PROPS */, ["price"]),
                            (_ctx.hasTaxHandlingEnabled)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.taxesSummaryLabel), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (_ctx.promoItem)
                      ? (_openBlock(), _createBlock(_component_project_promo_item, {
                          key: 1,
                          "image-size": 36,
                          class: "gfu-1of1 gfu-bt gfu-bt--caption",
                          "data-qa": "mini-wizard-expandable-project-promo-item"
                        }))
                      : _createCommentVNode("v-if", true),
                    ($options.canSubmit)
                      ? (_openBlock(), _createBlock(_component_mini_wizard_sticky_submit, { key: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($options.submitLabel), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    ($options.canCancel)
                      ? (_openBlock(), _createBlock(_component_base_button, {
                          key: 3,
                          disabled: !_ctx.currentPledge.canCancelPledge,
                          theme: "accent",
                          display: "block",
                          width: "narrow",
                          onClick: _withModifiers(_ctx.onCancelPledge, ["stop","prevent"]),
                          "data-qa": "mini-wizard-button:CancelPledge"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCancelPledgeButton), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled", "onClick"]))
                      : _createCommentVNode("v-if", true),
                    ($options.isRevertChangesVisible)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "gfu-link gfu-link--accent",
                            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => (_ctx.onRevertChanges && _ctx.onRevertChanges(...args)), ["prevent"])),
                            "data-qa": "mini-wizard-button:RevertChanges"
                          }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardRevertChangesButton), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($options.isManageYourPledgeVisible)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("a", {
                            class: "gfu-link gfu-link--accent",
                            href: _ctx.currentPledge.cartDetailsUrl,
                            "data-qa": "mini-wizard-button:ManageYourPledge"
                          }, _toDisplayString($options.cartDetailsLabel), 9 /* TEXT, PROPS */, _hoisted_10)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */), [
                  [_vShow, !$options.effectiveIsCollapsed]
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-processing"]))
    : _createCommentVNode("v-if", true)
}